import React, { useState } from "react";
import {
  Datagrid,
  List,
  NumberField,
  FunctionField,
  TopToolbar,
  WrapperField,
  DateField,
  useRecordContext,
  useRedirect,
  useListController,
} from "react-admin";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import CustomPagination from "../../Components/CustomPagination";
import DeleteDialog from "./dialogs/DeleteWheelSpin";
import { Loader } from "../Loader";

const CustomButton = () => {
  const navigate = useNavigate();
  const record = useRecordContext();

  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    navigate("/editwheelspin", { state: { record } });
  };

  const handleDeleteClick = () => {
    setOpenDialog(true);
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        variant="contained"
        id="basic-button"
        size="small"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        sx={{ textTransform: "none" }}
        onClick={handleClick}
      >
        Actions
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={handleEdit}>Edit</MenuItem>
        <MenuItem onClick={handleDeleteClick}>Delete</MenuItem>
      </Menu>
      <DeleteDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        record={record}
      />
    </>
  );
};

export const WheelSpin = () => {
  const {
    isLoading,
    total,
    page,
    perPage,
    setPage,
    setPerPage,
  } = useListController();

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const redirect = useRedirect();

  const WheelSpinListActions = () => {
    if (isLoading) return null;
    if (total >= 7) return null;

    return (
      <TopToolbar>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => redirect("/createwheelspin")}
          sx={{
            background: "#FFC107",
            color: "#0A0A0A",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#FFA000",
            },
          }}
        >
          Add Slots
        </Button>
      </TopToolbar>
    );
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Box
      sx={{
        mt: 4,
        backgroundColor: "#242424",
        borderRadius: 2,
        boxShadow: "none !important",
        padding: isSmallScreen ? { xs: 0, sm: 0 } : { xs: 1.5, sm: 2 },
      }}
    >
      <List
        title="Wheel Spin"
        actions={<WheelSpinListActions />}
        pagination={false}
        sort={{ field: "createdAt", order: "DESC" }}
        sx={{
          "& .RaList-actions": {
            flexWrap: "nowrap",
          },
          "& .RaFilterFormInput-spacer": { display: "none" },
        }}
      >
        <Box
            style={{
              width: "100%",
              overflowX: "auto",
            }}
          >
            <Box
              style={{
                width: "100%",
                position: isSmallScreen ? "absolute" : "relative",
              }}
            >
            <Datagrid
              bulkActionButtons={false}
              sx={{
                overflowX: "auto",
                overflowY: "hidden",
                width: "100%",
                maxHeight: "100%",
                "& .RaDatagrid-table": {
                  width: "100%",
                },
              }}
            >
              <WrapperField label="Actions">
                <CustomButton />
              </WrapperField>
              <NumberField source="day" label="Days" textAlign="left" />
              <NumberField source="minValue" label="Minimum" textAlign="left" />
              <NumberField source="maxValue" label="Maximum" textAlign="left" />
              <NumberField
                source="countZero"
                label="Better Luck"
                textAlign="left"
              />
              <FunctionField
                label="Slots (V1)"
                render={(record) => {
                  // Handle V1 format: simple numbers or legacy format
                  if (record.slots && Array.isArray(record.slots) && record.slots.length > 0) {
                    // Handle simple number array format (legacy V1)
                    if (typeof record.slots[0] === 'number') {
                      return record.slots
                        .map((amount, index) => ` ${amount}`)
                        .join(", ");
                    }
                    // Handle objects with Amount property (convert to simple display)
                    else if (typeof record.slots[0] === 'object' && record.slots[0].hasOwnProperty('Amount')) {
                      return record.slots
                        .map((slot, index) => `${index + 1}: ${slot.Amount || 0}`)
                        .join(", ");
                    }
                  }
                  return "No slots configured";
                }}
              />
              <FunctionField
                label="Slots (V2)"
                render={(record) => {
                  // Handle V2 format: objects with Amount and Type
                  if (record.slotsV2 && Array.isArray(record.slotsV2) && record.slotsV2.length > 0) {
                    const rewardTypeNames = {
                      1: "Crown",
                      2: "Gems", 
                      3: "Good Luck",
                    };
                    
                    return record.slotsV2
                      .map((slot, index) => {
                        const amount = slot.Amount || 0;
                        const typeName = rewardTypeNames[slot.Type] || `Type ${slot.Type}`;
                        return `${index + 1}: ${amount} ${typeName}`;
                      })
                      .join(", ");
                  }
                  return "No slotsV2 configured";
                }}
              />
              <DateField source="createdAt" label="Created Time" showTime />
            </Datagrid>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100% !important",
                margin: "16px 0px",
              }}
            >
              <CustomPagination
                page={page}
                perPage={perPage}
                total={total}
                setPage={setPage}
                setPerPage={setPerPage}
              />
            </Box>
          </Box>
        </Box>
      </List>
    </Box>
  );
};
